/**
 * 线上环境
 */
export const ONLINEHOST = 'https://zhengxinlm.com/index.php'

/**
 * 测试环境
 */

// export const QAHOST = 'https://zhengxinlm.com/index.php'
export const QAHOST = 'http://192.168.1.23:8193/index.php'

export const baseURL = process.env.NODE_ENV === 'production' ? ONLINEHOST : QAHOST

export const imgUrl = baseURL

export const fileUrl = baseURL.replace('/index.php','')

export const fileUpUrl = baseURL + '/api/upload_file?type=3'
export const certifiedEducationalAndTrainingInstitution_import_org = baseURL + '/api/admin/article/import_org'
export const certifiedEducationalAndTrainingInstitution_import_org_model = fileUrl + '/uploads/files/org.xlsx'

/*
* 缓存字段
* */
export const localAnStore = [
    {
        key: 'user',
        type: 'localStorage'
    },
    {
        key: 'token',
        type: 'localStorage'
    },

]
